import React from 'react';
import { ERROR_THEME_COLOR, MAIN_THEME_COLOR } from '../../const';
import {
  CANCELED_CHARGER_TASK_STATUS,
  CHARGER_TASK_STATUS_VALUE_LABEL_MAP,
  COMPLETED_CHARGER_TASK_STATUS,
  DONE_CHARGER_TASK_STATUS,
  ERROR_CHARGER_TASK_STATUS,
  IN_PROGRESS_CHARGER_TASK_STATUS,
  PENDING_CHARGER_TASK_STATUS,
  UNRESPONSIVE_CHARGER_TASK_STATUS,
  UPLOADING_CHARGER_TASK_STATUS,
} from './chargerTask';

const CircleIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="8" height="8" rx="4" fill="currentColor" />
  </svg>
);

export const CHARGER_STATUS_ACTIVE = 'active';
export const CHARGER_STATUS_ALARM = 'alarm';
export const DOWNLOAD = 'download';
export const IN_PROGRESS_BATCH_UPDATE = 'progress';
export const CHARGER_STATUS_ALERT = 'alert';
export const CHARGER_STATUS_AVAILABLE = 'available';
export const CHARGER_STATUS_INACTIVE = 'inactive';
export const CHARGER_STATUS_MONITORED = 'monitored';
export const CHARGER_STATUS_PARTIALLY_OOS = 'partially_oos';
export const CHARGER_STATUS_PENDING = 'pending';
export const CHARGER_STATUS_TOTALLY_OOS = 'totally_oos';
export const CHARGER_FIRMWARE_SENT = 'SENT';
export const EV_STATUS_CONNECTED = 'connected';
export const CONFIGURATION_REBOOT_REQUIRED = 'reboot_required';
export const CHANGES_PENDING = 'changes_pending';
export const CHARGER_STATUS_UNDEFINED = 'undefined';
export const CHARGER_STATUS_UNKNOWN = 'unknown';
export const CHARGER_ONLINE_YES = 'yes';
export const CHARGER_ONLINE_NO = 'no';
export const CABLE_CONNECTED = 'cable connected, not charging';
export const CABLE_DISCONNECTED = 'cable disconnected';
export const CABLE_CONNECTED_RESERVED = 'cable disconnected, reserved';
export const CHARGING = 'charging';
export const FAULTED = 'faulted';

export const BLUE_COLOR = '#009AD1';
export const ORANGE_COLOR = '#FF8A00';
export const DEEP_BLUE_COLOR = '#002D3D';
export const GRAY_COLOR = '#808080';
export const GREEN_COLOR = MAIN_THEME_COLOR;
export const RED_COLOR = ERROR_THEME_COLOR;

export const SYSTEM_GENERATED_CHARGER_NAME = 'CHARGER_NAME'
export const SYSTEM_GENERATED_COUNTRY = 'COUNTRY'
export const SYSTEM_GENERATED_ADDRESS = 'ADDRESS'

export const SYSTEM_GENERATED_FIELDS = [
  {
    key: SYSTEM_GENERATED_CHARGER_NAME,
    path: 'c_identity.c_name',
  },
  {
    key: SYSTEM_GENERATED_COUNTRY,
    path: 'c_identity.c_country',
  },
  {
    key: SYSTEM_GENERATED_ADDRESS,
    path: 'c_identity.c_address',
  },
]

export const cConfigurationStatuses = [
  {
    key: CHANGES_PENDING,
    label: 'Changes Pending',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: 'live',
    label: 'Live',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
];

export const chargingStatuses = [
  {
    key: 'not_connected',
    label: 'Cable Disconnected',
    Icon: CircleIcon,
    color: ORANGE_COLOR,
  },
  {
    key: 'connected_charging',
    label: 'Charging',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: 'faulted',
    label: 'Faulted',
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: 'connected_not_charging',
    label: 'Cable Connected, Not Charging',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: 'unknown',
    label: 'Unknown',
    color: GRAY_COLOR,
    Icon: CircleIcon,
  },
  {
    key: 'reserved_cable_disconnected',
    label: 'Cable Disconnected, Reserved',
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
];

export const chargerTaskStatuses = [
  {
    key: PENDING_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[PENDING_CHARGER_TASK_STATUS],
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CANCELED_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[CANCELED_CHARGER_TASK_STATUS],
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: IN_PROGRESS_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[IN_PROGRESS_CHARGER_TASK_STATUS],
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: COMPLETED_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[COMPLETED_CHARGER_TASK_STATUS],
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: UPLOADING_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[UPLOADING_CHARGER_TASK_STATUS],
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: UNRESPONSIVE_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[UNRESPONSIVE_CHARGER_TASK_STATUS],
    color: GRAY_COLOR,
    Icon: CircleIcon,
  },
  {
    key: DONE_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[DONE_CHARGER_TASK_STATUS],
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: ERROR_CHARGER_TASK_STATUS,
    label: CHARGER_TASK_STATUS_VALUE_LABEL_MAP[ERROR_CHARGER_TASK_STATUS],
    color: RED_COLOR,
    Icon: CircleIcon,
  },
];

export const chargerStatuses = [
  {
    key: CHARGER_STATUS_AVAILABLE,
    label: 'Available',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_ALERT,
    label: 'Alert',
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_PARTIALLY_OOS,
    label: 'Partially out of service',
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_TOTALLY_OOS,
    label: 'Totally out of service',
    color: DEEP_BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_MONITORED,
    label: 'Monitored',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_UNKNOWN,
    label: 'Unknown',
    color: GRAY_COLOR,
    Icon: CircleIcon,
  },
];

export const monitoredStatuses = chargerStatuses.filter(
  (item) => [CHARGER_STATUS_AVAILABLE, CHARGER_STATUS_MONITORED].indexOf(item.key) !== -1,
);

export const sessionStatusesValues = {
  OK: 'Ok',
  IN_PROGRESS: 'In Progress',
  LOCAL_STOP: 'Local Stop',
  REMOTE_STOP: 'Remote Stop',
  START_ERROR: 'Start Error',
  STOP_ERROR: 'Stop Error',
  ERROR: 'Error',
  EV_DISCONNECTED: 'EV Disconnected',
  EMERGENCY_STOP: 'Emergency Stop',
  ENERGY_LIMIT_REACHED: 'Energy Limit Reached',
  POWER_LOSS: 'Power Loss',
  REBOOT: 'Reboot',
  SOFT_RESET: 'Soft Reset',
  HARD_RESET: 'Hard Reset',
  UNLOCK_COMMAND: 'Unlock Command',
  DE_AUTHORIZED: 'Deauthorized',
  CLOUD_CMD: 'Cloud Cmd',
  OTHER: 'Other',
  FORCED_STOP: 'Forced Stop',
  SUSPENDED_EVSE: 'Suspended EVSE',
  SUSPENDED_EV: 'Suspended EV',
};
export const FWUpdateStatusesValues = {
  MANUFACTURED: 'Manufactured',
  TIME_OUT: 'Timed Out',
  RESPONSE_TIME_OUT: 'Response Time Out',
  ERROR: 'Error',
  IN_PROGRESS: 'In Progress',
  APPLIED: 'Applied',
  QUEUED: 'Queued',
  UNRESPONSIVE: 'Unresponsive',
  POSTPONED: 'Scheduled',
  CANCELLED: 'Cancelled',
};
export const conditionStatuses = [
  {
    key: CHARGER_STATUS_ACTIVE,
    label: 'Active',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_INACTIVE,
    label: 'Inactive',
    color: DEEP_BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_PENDING,
    label: 'Pending',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
];
export const sessionStatuses = [
  {
    key: sessionStatusesValues.OK.toLowerCase(),
    label: sessionStatusesValues.OK,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.IN_PROGRESS.toLowerCase(),
    label: sessionStatusesValues.IN_PROGRESS,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.LOCAL_STOP.toLowerCase(),
    label: sessionStatusesValues.LOCAL_STOP,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.REMOTE_STOP.toLowerCase(),
    label: sessionStatusesValues.REMOTE_STOP,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.EV_DISCONNECTED.toLowerCase(),
    label: sessionStatusesValues.EV_DISCONNECTED,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.ENERGY_LIMIT_REACHED.toLowerCase(),
    label: sessionStatusesValues.ENERGY_LIMIT_REACHED,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.SUSPENDED_EVSE.toLowerCase(),
    label: sessionStatusesValues.SUSPENDED_EVSE,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.SUSPENDED_EV.toLowerCase(),
    label: sessionStatusesValues.SUSPENDED_EV,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.REBOOT.toLowerCase(),
    label: sessionStatusesValues.REBOOT,
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.SOFT_RESET.toLowerCase(),
    label: sessionStatusesValues.SOFT_RESET,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.HARD_RESET.toLowerCase(),
    label: sessionStatusesValues.HARD_RESET,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.UNLOCK_COMMAND.toLowerCase(),
    label: sessionStatusesValues.UNLOCK_COMMAND,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.CLOUD_CMD.toLowerCase(),
    label: sessionStatusesValues.CLOUD_CMD,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.OTHER.toLowerCase(),
    label: sessionStatusesValues.OTHER,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.FORCED_STOP.toLowerCase(),
    label: sessionStatusesValues.FORCED_STOP,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.START_ERROR.toLowerCase(),
    label: sessionStatusesValues.START_ERROR,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.STOP_ERROR.toLowerCase(),
    label: sessionStatusesValues.STOP_ERROR,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.ERROR.toLowerCase(),
    label: sessionStatusesValues.ERROR,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.EMERGENCY_STOP.toLowerCase(),
    label: sessionStatusesValues.EMERGENCY_STOP,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.POWER_LOSS.toLowerCase(),
    label: sessionStatusesValues.POWER_LOSS,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: sessionStatusesValues.DE_AUTHORIZED.toLowerCase(),
    label: sessionStatusesValues.DE_AUTHORIZED,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
];
export const presentChargerState = [
  {
    key: CABLE_CONNECTED,
    label: 'Cable Connected, Not Charging',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CABLE_CONNECTED_RESERVED,
    label: 'Cable Disconnected, Reserved',
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CABLE_DISCONNECTED,
    label: 'Cable Disconnected',
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGING,
    label: 'Charging',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FAULTED,
    label: 'Faulted',
    color: RED_COLOR,
    Icon: CircleIcon,
  },
];
export const onlineStatuses = [
  {
    key: CHARGER_ONLINE_NO,
    label: 'No',
    color: DEEP_BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_ONLINE_YES,
    label: 'Yes',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
];
export const fwUpdateStatuses = [
  {
    key: FWUpdateStatusesValues.APPLIED.toLowerCase(),
    label: FWUpdateStatusesValues.APPLIED,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.MANUFACTURED.toLowerCase(),
    label: FWUpdateStatusesValues.MANUFACTURED,
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.POSTPONED.toLowerCase(),
    label: FWUpdateStatusesValues.POSTPONED,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.QUEUED.toLowerCase(),
    label: FWUpdateStatusesValues.QUEUED,
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.CANCELLED.toLowerCase(),
    label: FWUpdateStatusesValues.CANCELLED,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.RESPONSE_TIME_OUT.toLowerCase(),
    label: FWUpdateStatusesValues.RESPONSE_TIME_OUT,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.TIME_OUT.toLowerCase(),
    label: FWUpdateStatusesValues.TIME_OUT,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: FWUpdateStatusesValues.UNRESPONSIVE.toLowerCase(),
    label: FWUpdateStatusesValues.UNRESPONSIVE,
    color: RED_COLOR,
    Icon: CircleIcon,
  },
];
export const allChargerStatuses = [
  ...cConfigurationStatuses,
  ...chargingStatuses,
  ...chargerTaskStatuses,
  ...chargerStatuses,
  ...conditionStatuses,
  ...onlineStatuses,
  ...presentChargerState,
  ...sessionStatuses,
  ...fwUpdateStatuses,
  {
    key: CHARGER_STATUS_ALARM,
    label: 'Alarm',
    color: RED_COLOR,
    Icon: CircleIcon,
  },
  {
    key: DOWNLOAD,
    label: 'Completed',
    color: GREEN_COLOR,
    Icon: CircleIcon,
  },
  {
    key: IN_PROGRESS_BATCH_UPDATE,
    label: 'In Progress',
    color: BLUE_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CHARGER_STATUS_UNDEFINED,
    label: 'Undefined',
    color: GRAY_COLOR,
    Icon: CircleIcon,
  },
  {
    key: CONFIGURATION_REBOOT_REQUIRED,
    label: 'Reboot Required',
    color: ORANGE_COLOR,
    Icon: CircleIcon,
  },
];
export const firmwareUpdateStatuses = [
  { key: 'MANUFACTURED', label: FWUpdateStatusesValues.MANUFACTURED },
  { key: 'TIME_OUT', label: FWUpdateStatusesValues.TIME_OUT },
  { key: 'RESPONSE_TIME_OUT', label: FWUpdateStatusesValues.RESPONSE_TIME_OUT },
  { key: 'ERROR', label: FWUpdateStatusesValues.ERROR },
  { key: 'IN_PROGRESS', label: FWUpdateStatusesValues.IN_PROGRESS },
  { key: 'APPLIED', label: FWUpdateStatusesValues.APPLIED },
  { key: 'QUEUED', label: FWUpdateStatusesValues.QUEUED },
  { key: 'UNRESPONSIVE', label: FWUpdateStatusesValues.UNRESPONSIVE },
  { key: 'POSTPONED', label: FWUpdateStatusesValues.POSTPONED },
  { key: 'CANCELLED', label: FWUpdateStatusesValues.CANCELLED },
];
export const priorityStatuses = [
  { key: 'Bronze', label: '1 - Bronze' },
  { key: 'Silver', label: '2 - Silver' },
  { key: 'Gold', label: '3 - Gold' },
  { key: 'Platinum', label: '4 - Platinum' },
];
export const configurationStatuses = [
  { key: CHANGES_PENDING, label: 'Changes Pending' },
  { key: 'live', label: 'Live' },
  { key: CONFIGURATION_REBOOT_REQUIRED, label: 'Reboot Required' },
];

export const statusLabels = chargerStatuses
  .concat(monitoredStatuses)
  .concat(conditionStatuses)
  .concat(firmwareUpdateStatuses)
  .concat(priorityStatuses)
  .concat(configurationStatuses)
  .concat({ key: 'imported', label: 'Imported' })
  .concat({ key: 'ok', label: 'OK' })
  .concat({ key: 'SENT', label: 'In Progress' })
  .concat({ key: 'FAILED', label: 'Error' })
  .reduce((acc, { key, label }) => {
    acc[key] = label;

    return acc;
  }, {});
